import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
/*[2/24/22, PC_SH_19, Priyanka D]*/
const getAccessToken = () => {
    try {
        ;
        SDISVC.SamFed(
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShippingAccessToken", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const SubmitClick = (SubmitClickBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.Shipping_SubmitClick,
            JSON.stringify(SubmitClickBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response) { //PC_WW_1098_02
                        let contentData = { type: "SubmitClickData", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const GetRecipientDet = (RecipientBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.Shipping_PageLoad,
            JSON.stringify(RecipientBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "RecipientData", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const AccesstokenRes = (accesstokenObj) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.Shipping_AccessToken,
            JSON.stringify(accesstokenObj),
            (data) => {
                if (data.success) {
                    
                    if (data.response) { //PC_WW_1098_03
                        let contentData = { type: "AccesstokenRes", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const UpdatetrackNum = (UpdateTrackNoBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.Shipping_UpdateTransaction,
            JSON.stringify(UpdateTrackNoBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "UpdatetrackNum", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const PrintLabel = (PrintLabelBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.Shipping_PrintLabel,
            JSON.stringify(PrintLabelBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PrintLabel", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const deleteMultiAttach = (deleteMultiAttachBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Shipping,
            SDIConstants.methodNames.deleteMultiImage,
            JSON.stringify(deleteMultiAttachBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SHIPPING_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * deleteFavPage method gets called on removing page from favorite
 * @param deleteFavPageBO
 */
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SHIPPING_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * getCurrentFavPage method gets called on page load
 * @param getFavPageBO
 */
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SHIPPING_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

export { getAccessToken, GetRecipientDet, AccesstokenRes, SubmitClick, UpdatetrackNum, PrintLabel, deleteMultiAttach, deleteFavPage, insertFavPage, getCurrentFavPage }